var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23240_2293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 15H19.0002V17H17.0002V15ZM17.0002 11H19.0002V13H17.0002V11ZM17.0002 7H19.0002V9H17.0002V7ZM13.7402 7L15.0002 7.84V7H13.7402Z",
    fill: "#032530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3V4.51L12 5.84V5H21V19H17V21H23V3H10Z",
    fill: "#032530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7ZM10 19H13V11.16L8.17 8.09L3 11.38V19H6V13H10V19Z",
    fill: "#032530"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23240_2293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWork);
export default __webpack_public_path__ + "static/media/home-work.90e232a5b547cf59a6a48e1686f25953.svg";
export { ForwardRef as ReactComponent };